<h1 mat-dialog-title>{{ 'CONTACTS.INVITE_CONTACT' | translate }}</h1>

<div mat-dialog-content>

  <p>{{"CONTACTS.SELECT_CONTACT" | translate}}</p>
  <mat-form-field style="display:inline">
    <mat-label>{{"CONTACTS.SELECT_CONTACT" | translate}}</mat-label>
    <mat-select [(value)]="selectedValue" (selectionChange)="changeContact()">
      @for (contact of contacts; track contact){
      @if (contact.Company != null && contact.Company != '') { <mat-option value="{{contact.Id}}">{{contact.Name}} ({{contact.Company}})</mat-option> }
      @else {  <mat-option value="{{contact.Id}}">{{contact.Name}}</mat-option> }
      }
    </mat-select>
    @if (this.errorMessage.length > 0) {
      <div><span id="directCallLinkModalResult" class="text-danger">{{errorMessage}}</span></div>
    }
  </mat-form-field>


  @if (selectedContact != null) {
  <div class="contact-details">
    @if(showSendSMS){
    <div class="detail-item"><i class="fa-regular fa-paper-plane"></i> <span>{{selectedContact.Phone}}</span></div>
    }
    @if(showSendEmail){
    <div class="detail-item"><i class="fa-regular fa-envelope"></i> <span>{{selectedContact.Email}}</span></div>
    }
  </div>
  }

</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="addContact()">{{'ADD_CONTACT_DIALOG.BUTTON_ADD_CONTACT' | translate}}</button>
  <span style="flex:1"></span>
  <button mat-button [mat-dialog-close]="true">{{'MODAL.CLOSE' | translate}}</button>

  @if (showSendSMS) {
  <button mat-button [mat-dialog-close]="true" (click)="invite(false)">{{"CONTACTS.SEND_SMS" | translate}}</button>
  }
  @if (showSendEmail) {
  <button mat-button [mat-dialog-close]="true" (click)="invite(true)">{{"CONTACTS.SEND_MAIL" | translate}}</button>
  }
</div>
